const format = require('winston').format;
const {LEVEL, MESSAGE, SPLAT} = require('triple-beam');

// Format for log level.
const formatLevel = format(info => {
    if ((info[LEVEL] === 'error') || (info[LEVEL] === 'warn')) {
        info.level = info.level.toUpperCase();
    }

    info.level = info.level.padEnd(5);

    return info;
});

// Format error stack.
const formatError = format(info => {
    if (info.stack) {
        info.message = `${info.message}\n    ${info.stack}`;
        delete info.stack;
    }

    return info;
});

// Format timestamp.
const formatTimestamp = format(info => {
    info.level = `[${info.timestamp}] ${info.level}`;
    delete info.timestamp;

    return info;
});

// Final format for log files.
const formatForFile = format.combine(
    formatLevel(),
    formatError(),
    format.timestamp({ format: 'HH:mm:ss' }),
    formatTimestamp(),
    format.simple(),
);

// Final format for console.
const formatForConsole = format.combine(
    formatLevel(),
    formatError(),
    format.timestamp({ format: 'HH:mm:ss' }),
    formatTimestamp(),
    format.simple(),
);

// Final format for dev console.
const formatForDevConsole = format.combine(
    formatLevel(),
    formatError(),
    format.colorize({ all: true, colors: { error: 'red', warn: 'yellow', info: 'reset', debug: 'grey' }}),
    format.timestamp({ format: 'HH:mm:ss' }),
    formatTimestamp(),
    format.simple(),
);

export {formatForConsole, formatForDevConsole, formatForFile}
